<!-- 公众号与支付 -->
<template>
    <div class="container">
        <Form :model="formData" label-position="right" :label-width="150">
            <div class="form_title">公众号设置</div>
            <FormItem label="公众号二维码：">
                <div class="image-div mb-24">
                    <div class="form_upload mr-24 " @click="openModal(1)">
                        <Icon type="ios-add" size="40" color="#AEAEB3"/>
                    </div>
                    <div v-if="show_pic" class="form_upload position_relative">
                        <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg"/>
                        <img class="form_img" :src="show_pic" @click="previewImg(show_pic)">
                    </div>
                </div>
            </FormItem>
            <FormItem label="启用公众号：">
                <i-switch v-model="formData.is_wx" size="large" true-color="#FF761D" :true-value="1" :false-value="0">
                    <span slot="open">开启</span>
                    <span slot="close">关闭</span>
                </i-switch>
            </FormItem>
            <template v-if="formData.is_wx">
                <FormItem label="ApplD：">
                    <Input class="w300" type="text" v-model="formData.app_id" placeholder="请输入ApplD"></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                        <div slot="content"><p>请填写您的微信认证服务号AppID，设置好以后请不要更换，否则会造成活动领取限制失效，用户重复领取红包</p></div>
                    </Tooltip>
                </FormItem>
                <FormItem label="AppSecret：">
                    <Input class="w300" type="text" v-model="formData.app_secret" placeholder="请输入AppSecret"></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                        <div slot="content"><p>请填写您的微信认证服务号AppSecret，并在公众平台中设置oAuth授权域名为当前系统域名</p></div>
                    </Tooltip>
                </FormItem>
            </template>
            <div class="form_title">微信支付设置</div>
            <FormItem label="启用微信支付：">
                <i-switch v-model="formData.is_pay" size="large" true-color="#FF761D" :true-value="1" :false-value="0">
                    <span slot="open">开启</span>
                    <span slot="close">关闭</span>
                </i-switch>
            </FormItem>
            <template v-if="formData.is_pay">
                <FormItem label="商户号：">
                    <Input class="w300" type="text" v-model="formData.merchant_no" placeholder="请输入商户号"></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                        <div slot="content"><p>请填写使用或借用的微信支付商户号，开通微信支付才能获得商户号</p></div>
                    </Tooltip>
                </FormItem>
                <FormItem label="商户支付密钥：">
                    <Input class="w300" type="text" v-model="formData.pay_secret" placeholder="请输入商户支付密钥"></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                        <div slot="content"><p>请填写使用或借用的微信支付商户平台的支付密钥</p></div>
                    </Tooltip>
                </FormItem>
                <FormItem label="证书序列号：">
                    <Input class="w300" type="text" v-model="formData.serial_number" placeholder="请输入证书序列号"></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                        <div slot="content"><p>请填写使用或借用的微信支付商户平台的证书序列号</p></div>
                    </Tooltip>
                </FormItem>
                <FormItem label="支付证书key：">
                    <div class="display_flex">
                        <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :format="['jpg', 'png', 'pdf', 'pem']"
                        :max-size="2048"
                        :on-format-error="handleFormatError"
                        :on-success="keySuccess"
                        :on-progress="handleProgress"
                        :headers="headers"
                        :action="uploadImg"
                        >
                            <Button>{{formData.apiclient_key ? '已成功上传' : '点击上传商户支付证书key'}}</Button>
                        </Upload>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content"><p>从商户平台上下载支付证书，解压并取得其中的<span class="theme-color">apiclient-key.pem</span>上传此文件</p></div>
                        </Tooltip>
                    </div>
                </FormItem>
                <FormItem label="支付证书cert：">
                    <div class="display_flex">
                        <Upload
                            ref="upload"
                            :show-upload-list="false"
                            :format="['jpg', 'png', 'pdf', 'pem']"
                            :max-size="2048"
                            :on-format-error="handleFormatError"
                            :on-success="certSuccess"
                            :on-progress="handleProgress"
                            :headers="headers"
                            :action="uploadImg"
                            >
                            <Button>{{formData.apiclient_cert ? '已成功上传' : '点击上传商户支付证书cert'}}</Button>
                        </Upload>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content"><p>从商户平台上下载支付证书，解压并取得其中的<span class="theme-color">apiclient-cert.pem</span>上传此文件</p></div>
                        </Tooltip>
                    </div>
                </FormItem>
                <FormItem label="服务器Ip地址：">
                    <Input class="w300" type="text" v-model="formData.ip" placeholder="请输入服务器Ip"></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                        <div slot="content"><p>红包接口需要服务器IP，系统将自动获取您的服务器IP，如果获取失败，请手动填写</p></div>
                    </Tooltip>
                </FormItem>
                <FormItem label="商家转账到零钱：">
                    <RadioGroup v-model="formData.transfer_api">
                        <Radio label="2" style="margin-right: 48px;">新版</Radio>
                        <Radio label="1">旧版</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem v-if="formData.transfer_api == 2" label="转账场景ID：">
                    <Input class="w300" type="text" v-model="formData.transfer_scene_id" placeholder="请输入转账场景ID"></Input>
                </FormItem>
            </template>
            <div class="form_title">腾讯地图设置</div>
            <FormItem class="form-map" label="腾讯地图key：">
                <Input class="w300" type="text" v-model="formData.tencent_map_key" placeholder="请输入腾讯地图key"></Input>
                <div class="form-p">
                    配置腾讯地图Key时，请在应用授权IP下增加125.122.16.70。<br>
                    如果使用独立服务器，请把自己的服务器IP配置在授权IP中
                </div>
            </FormItem>
            <div class="display_flex">
                <div class="form_title">百度语音设置</div>
                <Tooltip max-width="250" placement="right" theme="light">
                    <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                    <div slot="content">登陆百度智能云创建应用，使用短文本在线合成API</div>
                </Tooltip>
            </div>
            <FormItem label="百度语音key：">
                <Input class="w300" type="text" v-model="formData.baidu_voice_key" placeholder="请输入百度语音key"></Input>
            </FormItem>
            <FormItem label="百度语音secret：">
                <Input class="w300" type="text" v-model="formData.baidu_voice_secret" placeholder="请输入百度语音secret"></Input>
            </FormItem>
            <div class="footer">
                <Button class="theme-bc ml-24" type="warning" @click="submitForm">确定</Button>
            </div>
        </Form>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import { 
    system_wx_index, 
    system_wx_save,
} from '@/api/index';
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: { pictureLibrary },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            uploadImg: config.apiUrl + "/api/other/upload",
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            formData: { 
                is_wx: "",
                app_id: "",
                app_secret: "",
                is_pay: "",
                merchant_no: "",
                pay_secret: "",
                ip: "",
                apiclient_key: "",
                apiclient_cert: "",
                serial_number: "",
                pic: "",
                tencent_map_key: "",
                baidu_voice_key: "",
                baidu_voice_secret: "",
                transfer_api: "",
                transfer_scene_id: 1000,
            },
            show_pic: '',
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_pic = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.pic = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList(){
            system_wx_index().then((res) => {
                if(res.data.admin_id){
                    this.formData.is_wx = res.data.is_wx;
                    this.formData.app_id = res.data.app_id;
                    this.formData.tencent_map_key = res.data.tencent_map_key;
                    this.formData.baidu_voice_key = res.data.baidu_voice_key;
                    this.formData.baidu_voice_secret = res.data.baidu_voice_secret;
                    this.formData.app_secret = res.data.app_secret;
                    this.formData.is_pay = res.data.is_pay;
                    this.formData.merchant_no = res.data.merchant_no;
                    this.formData.pay_secret = res.data.pay_secret;
                    this.formData.ip = res.data.ip;
                    this.formData.transfer_api = res.data.transfer_api + '';
                    this.formData.apiclient_key = res.data.apiclient_key;
                    this.formData.apiclient_cert = res.data.apiclient_cert;
                    this.formData.serial_number = res.data.serial_number;
                    this.formData.pic = res.data.pic;
                    this.formData.transfer_scene_id = res.data.transfer_scene_id ? res.data.transfer_scene_id : 1000;
                    if(res.data.pic){
                        this.show_pic = res.data.show_pic;
                    }
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 确定(提交表单)
        submitForm(){
            system_wx_save(this.formData).then( res => {
                this.getList();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        // 文件上传时
        handleProgress(){
            this.$Message.loading({
                content: '上传中...',
                duration: 0
            }) 
        },
        // 文件上传类型错误
        handleFormatError(){                
            this.$Message.destroy();
            this.$Message.warning("暂不支持上传此格式");
        },
        // 支付证书key
        keySuccess(e){
            this.formData.apiclient_key = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        // 支付证书cert
        certSuccess(e){
            this.formData.apiclient_cert = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        // 上传微信支付公钥证书cert
        publicSuccess(e){
            this.formData.public_key_cert = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        platSuccess(e){
            this.formData.plat_key_cert = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        delImg(){
            this.show_pic = ''
            this.formData.pic = ''
        },
        // 预览图片
        previewImg(item){
            if(item){
                window.open(item);
            }
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    position: relative;
}
.form_title {
    margin-bottom: 24px;
    color: #484E66;
    font-weight: 600;
}
.form_upload {
    width: 80px;
    height: 80px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #9FA5BB;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.form_img {
    width: 78px;
    height: 78px;
    border-radius: 5px;
}
.footer {
    margin: 24px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
.display_flex {
    display: flex;
}
.form-p {
    margin-top: 12px;
    font-size: 12px;
    color: #9FA5BB;
}
.form-map ::v-deep .ivu-form-item-content{
    line-height: normal !important;
}
::v-deep .ivu-radio-group .ivu-radio-wrapper-checked .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff761d;
}
::v-deep .ivu-radio-group .ivu-radio-wrapper-checked .ivu-radio-checked .ivu-radio-inner:after {
    background-color: #ff761d;
}
.image-div {
    display: flex;
    align-items: center;
}
.position_relative {
    position: relative;
}
.form_icon {
    position: absolute;
    top: -10px;
    right: -10px;
}
</style>